module.exports = __webpack_public_path__ + "img/22.f4a93407.png";